import React from 'react'
import { compose } from 'utils/compose'
import { useHighlightsBookShelf } from './HighlightsBookShelf.hooks'
import BookShelf from 'components/modular/shelves/book-shelf'
import type { HighlightsBookShelfProps } from './HighlightsBookShelf.types'
import withLazyLoad from 'utils/with-lazy-load'
import { useTranslation } from 'i18n'
import { MAX_SHELF_LENGTH } from '../contants'
import { Wrapper } from './HighlightsBookShelf.style'
import { tokens } from '@arvoreeducacao/bonsai-ds'

const HighlightsBookShelf: React.FC<HighlightsBookShelfProps> = ({
  contentFilter,
  isStudentView = false,
  degree
}) => {
  const { content, isLoading, onClickBook, onClickBtnGetMore } =
    useHighlightsBookShelf(contentFilter, isStudentView, degree)

  const { t } = useTranslation()
  const exceedsShelfLength = content.length >= MAX_SHELF_LENGTH

  const backgroundColorByContent = () => {
    if (contentFilter === 'LIVROS' || contentFilter === 'LER') {
      return tokens.colors.blue100
    }
    return `rgba(0, 0, 0, 0)`
  }

  if (!content?.length) {
    return
  }

  const hasRecommendedBookShelf =
    document.getElementById('recommended-book-shelf') !== null

  return (
    <Wrapper color={hasRecommendedBookShelf && backgroundColorByContent()}>
      <BookShelf
        loading={isLoading}
        contentFilter={contentFilter}
        title={t('Destaques')}
        subtitle={''}
        size={'xlarge'}
        coversList={content}
        onClickCover={onClickBook}
        onClickBtnGetMore={onClickBtnGetMore}
        isSeeAllButtonVisible={exceedsShelfLength}
        showInfo
      />
    </Wrapper>
  )
}
export default compose<React.FC<HighlightsBookShelfProps>>(
  withLazyLoad({ once: true, height: 430, resize: true })
)(HighlightsBookShelf)
